import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    queries: new Object
};

const queryCacheSlice = createSlice({
    name: "queryCache",
    initialState,
    reducers: {
        addQuery: (state, action) => {
            var key = action.payload.requestType;
            if (action.payload.payload !== null) {
                key = key + "_" + JSON.stringify(action.payload.payload)
            }
            var newQueryState = state.queries;
            newQueryState[key] = action.payload.response;
            state.queries = newQueryState;
        }
    }
});

export const { addQuery } = queryCacheSlice.actions;
export default queryCacheSlice.reducer;